// Via https://stackoverflow.com/a/45486495.
export const TYPES = ['image/gif', 'image/jpeg', 'image/png', 'image/webp'] as const;
type TypeTuple = typeof TYPES;
export type Type = TypeTuple[number];
